import { ScrollAreaContext } from '#pplx/frontend/aether/internal/scroll-area/ScrollAreaContext.js';
import { useContext } from 'react';
/**
 * Returns the scroll overflow state of the nearest ancestor ScrollArea.
 * Must be called from a component rendered inside a ScrollArea.
 */
export function useScrollArea() {
    return useContext(ScrollAreaContext);
}
//# sourceMappingURL=index.js.map